import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';

const CommentCard = (props) => {
    const { avatarCharacter, title, subTitle, content, action, cardStyle, contentStyle, actionStyle, disableActionSpacing } = props;
    return (
        <Card style={cardStyle}>
            <CardHeader
                avatar={
                    <Avatar aria-label="recipe">
                        {avatarCharacter}
                    </Avatar>
                }
                title={title}
                subheader={subTitle}
            />
            <CardContent style={contentStyle}>
                {content}
            </CardContent>
            <CardActions style={actionStyle} disableSpacing={disableActionSpacing}>
                {action}
            </CardActions>
        </Card>
    );
}

CommentCard.propTypes = {
    action: PropTypes.any,
    content: PropTypes.any,
    title: PropTypes.any,
    subTitle: PropTypes.any,
    avatarCharacter: PropTypes.any,
    cardStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    actionStyle: PropTypes.object,
    disableActionSpacing: PropTypes.bool

}

CommentCard.defaultProps = {
    action: "",
    content: "N/A",
    title: "N/A",
    subTitle: "N/A",
    avatarCharacter: "?",
    cardStyle: {},
    contentStyle: {},
    actionStyle: {},
    disableActionSpacing: false

}

export default CommentCard;